import { type Tier, TierHierarchy } from '@mc/api'

/**
 * Match the first tier, aka 'Standard' tier
 * @param tier - The tier to match
 * @returns true if the tier is the first tier
 */
export const first = (tier: Tier) =>
  tier.hierarchy === TierHierarchy.INDIVIDUAL && !isSingleClassTier(tier)

/**
 * Match the second tier, aka 'Plus' tier
 * @param tier - The tier to match
 * @returns true if the tier is the second tier
 */
export const second = (tier: Tier) => tier.hierarchy === TierHierarchy.DUO

/**
 * Match the third tier, aka 'Premium' tier
 * @param tier - The tier to match
 * @returns true if the tier is the third tier
 */
export const third = (tier: Tier) => tier.hierarchy === TierHierarchy.FAMILY

/**
 * Match the fourth tier, aka 'Family Plus' tier.
 * It is a special tier that was introduced as part of the Premium Painted Door experiment.
 * It is not available in the default tier collection.
 * @param tier - The tier to match
 * @returns true if the tier is the fourth tier
 */
export const fourth = (tier: Tier) =>
  tier.hierarchy === TierHierarchy.FAMILY_PLUS

/**
 * Match the single class tier, aka 'Single Class Credit' tier.
 * It is a special tier that was introduced as part of the Painted Door Single Class experiment.
 * It is not available in the default tier collection.
 * @param tier - The tier to match
 * @returns true if the tier is the single class tier
 */
export const singleClass = (tier: Tier) =>
  tier.hierarchy === TierHierarchy.INDIVIDUAL && isSingleClassTier(tier)

const isSingleClassTier = (tier: Tier) =>
  !!tier.basicPlanIdentifier?.startsWith('single-class')
